/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailTextDto
 */
export interface EmailTextDto {
    /**
     * 
     * @type {string}
     * @memberof EmailTextDto
     */
    emailText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailTextDto
     */
    emailSubject?: string | null;
}

/**
 * Check if a given object implements the EmailTextDto interface.
 */
export function instanceOfEmailTextDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailTextDtoFromJSON(json: any): EmailTextDto {
    return EmailTextDtoFromJSONTyped(json, false);
}

export function EmailTextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailTextDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailText': !exists(json, 'emailText') ? undefined : json['emailText'],
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
    };
}

export function EmailTextDtoToJSON(value?: EmailTextDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailText': value.emailText,
        'emailSubject': value.emailSubject,
    };
}

